
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_93Ivgxkvv3fRMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexs5NSmEfqoPMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as gxtcBkZJE9SMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexHMGcLGZeWOMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as indexN50IASi9idMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexkUwEYGFQV4Meta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
import { default as searchXydBLrVY0uMeta } from "/home/runner/work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexxK7nAkKDMhMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93OqnarYBgbyMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexWxCfjwsEh7Meta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93yIo7bFKLpxMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
export default [
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexs5NSmEfqoPMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "g",
    path: "/g",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexN50IASi9idMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexkUwEYGFQV4Meta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexxK7nAkKDMhMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  }
]